import { FC } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { ShouldBlock, useBlocker } from '@cvt/contexts';
import { useDictionary } from '@cvt/hooks/useDictionary';


type Props = {
  shouldBlock: ShouldBlock
}

export const Blocker: FC<Props> = ({ shouldBlock }) => {
  const { dialogs } = useDictionary();
  const blocker = useBlocker(shouldBlock);

  const handleProceed = () => blocker.proceed?.();
  const handleCancel = () => blocker.reset?.();

  const handleClose = (event: unknown, reason: string) => {
    if (reason !== 'backdropClick') {
      handleCancel();
    }
  };

  return (
    <Dialog
      disableEscapeKeyDown
      open={blocker.state === 'blocked'}
      onClose={handleClose}
    >
      <DialogTitle>{dialogs.unsavedChanges.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {dialogs.unsavedChanges.content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>{dialogs.buttonCancel}</Button>
        <Button onClick={handleProceed} autoFocus>
          {dialogs.buttonProceed}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
